import { string2money } from 'common/utils/string';
import Stack from 'components/commons/stack';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import {
  AbsolutePosition,
  Container,
  ItemBasePriceText,
  ItemText,
  ItemTypeText,
  PanelFooter,
  PanelFooterPriceText,
  PanelFooterTotalText,
  PanelSummaryContainer,
  PanelSummaryContent,
} from './style';

type DataType = {
  totalPrice: string;
  details: {
    type: 'passenger' | 'vehicle' | 'facility';
    items: {
      name?: string;
      qty?: number;
      basePrice?: number;
      isFree?: boolean;
      insurancePrice?: number;
      insuranceQty?: number;
    }[];
  }[];
};

interface Props {
  data?: DataType;
}

export default function PriceDetailTab(props: Props) {
  const { t } = useTranslation();

  return (
    <Container>
      <PanelSummaryContainer>
        <AbsolutePosition>
          <PanelSummaryContent>
            {props.data?.details
              .filter((curr) => curr.items.length !== 0)
              .map((detail) => (
                <Stack rootCss={{ mb: 20 }}>
                  <Stack gap="sm">
                    <ItemTypeText>{t(`common:${detail.type}`)}</ItemTypeText>
                    <Stack.Item>
                      <Stack gap="xs">
                        {detail.items.map((item) => {
                          return (
                            <Stack.Item
                              direction="horizontal"
                              justify="between"
                            >
                              <Stack>
                                <ItemText>{`${item.name} (x${item.qty})${
                                  item?.insuranceQty && !item.isFree
                                    ? ` + ${t('booking:insurance')} (x${
                                        item?.insuranceQty
                                      }) @ Rp. ${string2money(
                                        item?.insurancePrice || 0,
                                      )}`
                                    : ''
                                }`}</ItemText>
                                <ItemBasePriceText>{`@ Rp ${string2money(
                                  item?.basePrice || 0,
                                )}`}</ItemBasePriceText>
                              </Stack>
                              <ItemTypeText
                                isRed={item.isFree}
                                css={{
                                  minWidth: '40%',
                                  display: 'flex',
                                  justifyContent: 'flex-end',
                                }}
                              >{`${item.isFree ? '-' : ''}Rp ${string2money(
                                (
                                  (item?.qty || 0) * (item?.basePrice || 0) +
                                  (item?.insuranceQty
                                    ? (item?.insuranceQty || 0) *
                                      (item?.insurancePrice || 0)
                                    : 0)
                                ).toString(),
                              )}`}</ItemTypeText>
                            </Stack.Item>
                          );
                        })}
                      </Stack>
                    </Stack.Item>
                  </Stack>
                </Stack>
              ))}
          </PanelSummaryContent>
        </AbsolutePosition>
      </PanelSummaryContainer>
      <PanelFooter>
        <PanelFooterTotalText>{t('common:total')}</PanelFooterTotalText>
        <PanelFooterPriceText>
          Rp {string2money(props.data?.totalPrice || '0')}
        </PanelFooterPriceText>
      </PanelFooter>
    </Container>
  );
}
